/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Bumble 다운받기",
      "모두 수락",
      "옵션 관리하기",
      "쿠키 정책",
      "돌아가기",
      "올바르지 않은 전화번호",
      "© {{current_year}} Bumble | All Rights Reserved",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "소개",
      "앰배서더",
      "블로그",
      "당사 사이트는 쿠키를 사용합니다. 설정을 변경하지 않는다면 귀하는 당사의 쿠키 사용에 동의하는 것으로 간주됩니다.",
      "앱 다운로드",
      "Android용 다운로드",
      "iOS용 다운로드",
      "죄송합니다. 현재 찾으시는 페이지를 발견할 수 없습니다.",
      "로그인하기",
      "가입하기",
      "함께 즐겨보세요!",
      "앗, 오류가 발생했어요"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "일"
            ],
            "singular": [
                  "일"
            ]
      },
      "hour": {
            "plural": [
                  "시간"
            ],
            "singular": [
                  "시간"
            ]
      },
      "minute": {
            "plural": [
                  "분"
            ],
            "singular": [
                  "분"
            ]
      },
      "month": {
            "plural": [
                  "개월"
            ],
            "singular": [
                  "개월"
            ]
      },
      "second": {
            "plural": [
                  "초"
            ],
            "singular": [
                  "초"
            ]
      },
      "year": {
            "plural": [
                  "년"
            ],
            "singular": [
                  "년"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
